import { SWRConfiguration } from 'swr';

import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';
import { AppModules } from '~/services/Permissions';

import { useModulesConfig } from '../company';

import { CustomDataFieldAttributes } from './types';

export const getCustomEmployeeFieldAttributes = (): Promise<
  CustomDataFieldAttributes[]
> => {
  return fetchFromOldApi(`/json/customdata/entity/EMPLOYEE/attribute`).then(
    (r) => r.json(),
  );
};

export const useCustomDataAttributes = (
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { isModuleEnabled } = useModulesConfig();
  const isCustomDataEnabled = isModuleEnabled(AppModules.CUSTOM_DATA);

  const { data, isLoading, error } = useArraySWR<CustomDataFieldAttributes>(
    !isDisabled && isCustomDataEnabled
      ? ['getCustomEmployeeFieldAttributes']
      : null,
    () => getCustomEmployeeFieldAttributes(),
    swrConfig,
  );

  return {
    data,
    isLoading,
    error,
  };
};
